import { memo } from 'react';

import { Form, Input as AntInput, Space } from 'antd';
import cn from 'classnames';

import cls from './input-min-max.module.css';

interface InputMinMaxProps {
    className?: string;
    isBlock?: boolean;
    maxName: string;
    maxPlaceholder?: string;
    minName: string;
    minPlaceholder?: string;
    step?: string;
    type?: string;
}

export const InputMinMax = memo((props: InputMinMaxProps) => {
    const {
        className,
        isBlock,
        maxName,
        maxPlaceholder,
        minName,
        minPlaceholder,
        step = '0.01',
        type = 'number',
        ...otherProps
    } = props;

    return (
        <Space className={cn(className, cls.root, { [cls.block]: isBlock })}>
            <Form.Item
                name={minName}
                noStyle
            >
                <AntInput
                    placeholder={minPlaceholder}
                    step={step}
                    type={type}
                    {...otherProps}
                />
            </Form.Item>
            <Form.Item
                name={maxName}
                noStyle
            >
                <AntInput
                    placeholder={maxPlaceholder}
                    step={step}
                    type={type}
                    {...otherProps}
                />
            </Form.Item>
        </Space>
    );
});

InputMinMax.displayName = 'InputMinMax';
